import script from "./SearchPageSearchResultsButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchResultsButtons.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchResultsButtons.vue?vue&type=style&index=0&id=5683bcd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5683bcd2"]])

export default __exports__